import { useInject } from '@actr/di/src/hook/use-inject';
import { SeoAddReviewService } from '@actr/stores/src/services/services/seo/review';
import { AppStore } from '@actr/stores/src/stores/stores/common/app';
import { SeoAddReviewStore } from '@actr/stores/src/stores/stores/seo/reviews/review';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';

import AddReviewModal from '@/components/reviews/modals/add-review-modal';
import ErrorModal from '@/components/reviews/modals/error-modal';
import SuccessAddedReviewModal from '@/components/reviews/modals/success-added-review-modal';
import UnauthorizedModal from '@/components/reviews/modals/unauthorized-modal';
import LocalAuthStore from '@/store/auth';

export type ModalsGroupProps = {
    isShowAddReviewModal: boolean;
    setShowAddReviewModal: (value: boolean) => void;
}

const ModalsGroup: React.FC<ModalsGroupProps> = ({ isShowAddReviewModal, setShowAddReviewModal }) => {
  const app = useInject(AppStore);
  const { isMobile } = app;
  const review = useInject(SeoAddReviewStore);
  const seoAddReviewService = useInject(SeoAddReviewService);
  const auth = useInject(LocalAuthStore);

  const [isOpenUnauthorizedModal, setOpenUnauthorizedModal] = useState(false);
  const [isOpenAddReviewModal, setOpenAddReviewModal] = useState(false);
  const [isOpenErrorModal, setErrorModalOpen] = useState(false);
  const [isOpenReviewSuccessAddedModal, setOpenReviewSuccessAddedModal] = useState(false);

  function handleAddReview() {
    if (!auth.isAuthorized) {
      setOpenUnauthorizedModal(true);
    }
    if (auth.isAuthorized) {
      setOpenAddReviewModal(true);
    }
  }
  useEffect(() => {
    if (isShowAddReviewModal) {
      handleAddReview();
    }
  }, [isShowAddReviewModal]);

  function handleSendReview() {
    if (review.form.validate() && review.rating) {
      seoAddReviewService.addReview()
        .then(() => {
          setOpenAddReviewModal(false);
          setShowAddReviewModal(false);
          setOpenReviewSuccessAddedModal(true);
          review.reset();
        })
        .catch(() => {
          setErrorModalOpen(true);
          setOpenAddReviewModal(false);
        });
    }
  }

  function handleCloseUnauthorizedModal() {
    setOpenUnauthorizedModal(false);
    setShowAddReviewModal(false);
  }

  function handleCloseAddReviewModal() {
    setOpenAddReviewModal(false);
    setShowAddReviewModal(false);
  }

  return (
    <>
      <UnauthorizedModal
        isShowModal={isOpenUnauthorizedModal}
        onClose={handleCloseUnauthorizedModal}
        isMobile={isMobile}
      />
      <AddReviewModal
        isShowModal={isOpenAddReviewModal && auth.isAuthorized}
        onClose={handleCloseAddReviewModal}
        review={review}
        handleSendReview={handleSendReview}
        isMobile={isMobile}
      />
      <SuccessAddedReviewModal
        isShowModal={isOpenReviewSuccessAddedModal}
        onClose={() => setOpenReviewSuccessAddedModal(false)}
        isMobile={isMobile}
      />
      <ErrorModal
        isShowModal={isOpenErrorModal}
        onClose={() => setErrorModalOpen(false)}
        isMobile={isMobile}
      />
    </>
  );
};

export default observer(ModalsGroup);
